var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-inline-flex"},_vm._l((3),function(x,i){return _c('div',{key:x,style:(_vm.width)},[(_vm.score > i-1)?_c('v-icon',{attrs:{"size":_vm.iconSize,"color":"red"}},[_vm._v("mdi-fire")]):_c('v-icon',{attrs:{"size":_vm.iconSize,"color":"grey"}},[_vm._v("mdi-fire")])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }